export default "__VITE_ASSET__36902807__"